import { feedbackTextForDisplay } from './feedback-text.mjs';
import { getActivityFeedbackAudioPath } from './activity-feedback-audio.mjs';

// Translate shared feedback references at the native boundary. The stored
// activity keeps its string number and INHERITED marker for future languages.
export function resolveNativeFeedback(feedback, { translate, getStringAudio, language = 'en', currentActivity, s3bucketPublicURL } = {}) {
  const resolved = { ...feedback };
  const stringNumber = Number.isInteger(feedback?.text) && feedback.text > 0 ? feedback.text : null;
  if (stringNumber !== null) {
    const fallback = feedbackTextForDisplay(null, feedback.isCorrect, language);
    const text = translate?.(stringNumber, fallback, true, false, language);
    resolved.text = typeof text === 'string' && text.trim() ? text : fallback;
  }
  if (feedback?.audio === 'INHERITED') {
    // INHERITED is metadata, never a filename in the activity content folder.
    delete resolved.audio;
    const saved = stringNumber !== null ? getActivityFeedbackAudioPath({
      currentActivity, s3bucketPublicURL, localeOverride: language, stringNumber,
    }) : null;
    if (saved) resolved.audioSrc = saved;
    else {
      const shared = stringNumber !== null ? getStringAudio?.(stringNumber, true) : null;
      if (shared?.audio && typeof shared.path === 'string' && /^https?:\/\//.test(shared.path)) {
        resolved.audioSrc = `${shared.path.replace(/\/?$/, '/')}${encodeURIComponent(shared.audio)}`;
      }
    }
  }
  resolved.specific = Boolean(stringNumber !== null ||
    (typeof resolved.text === 'string' && resolved.text.trim()) || resolved.audioSrc ||
    (resolved.audio && resolved.audio !== 'INHERITED'));
  return resolved;
}
